/**
 * Dependencies.
 */
import { RouteConfig } from 'vue-router';

import { ROUTES } from '@/constants/routes.constant';

/**
 * Export.
 */
export default [
  {
    // beforeEnter: () => {
    //   window.location.href = `/apps/partner/information${window.location.search}`;
    // },
    component: () =>
      import(
        /* webpackChunkName: "partner" */ '@/modules/details/scenes/details.scene.vue'
      ),
    meta: { requiresAuth: true },
    name: ROUTES.PARTNER.DETAILS,
    path: 'partner/details'
  }
] as RouteConfig[];
